import React from 'react';
// import { TextField } from '@mui/material';
import { TextField } from '../../../../../components';
import { useField } from 'formik';
import { IHubspotField } from '../../../../../models/hubspot-forms';
import { stripHtml } from '../../../util';
interface TextFieldAdapterProps {
  field: IHubspotField;
}

export const TextFieldAdapter: React.FC<TextFieldAdapterProps> = ({ field }) => {
  const [formikField, meta] = useField(field.name);

  if (field.hidden) {
    return null; // Don't render hidden fields
  }

  // Extract validation error state
  const showError = meta.touched && Boolean(meta.error);

  return (
    <TextField
      {...formikField}
      id={field.name}
      name={field.name}
      type={field.fieldType === 'email' ? 'email' : 'text'}
      label={stripHtml(field.label) || field.name}
      required={field.required}
      error={showError}
      helperText={showError ? meta.error : ''}
      fullWidth
      margin="dense"
      InputLabelProps={{
        shrink: true
      }}
    />
  );
};
